import { AxiosResponse } from 'axios'

import ClientSDK from '../../../App/ClientSDK'

import { IDeletePerson } from './IDeletePerson'

class Client {
    static deletePerson = (uuid: string): Promise<IDeletePerson> =>
        ClientSDK.instance()
            .delete(`hr/persons/${uuid}`)
            .then((response: AxiosResponse): IDeletePerson => {
                return response.data
            })
}

export default Client
